// src/components/modals/AuthModal.jsx
import React, { useState } from 'react';
import { Lock, User, ArrowRight } from 'lucide-react';
import { toast } from 'react-toastify';

const AuthModal = ({ setActiveScreen }) => {
  const [isLogin, setIsLogin] = useState(true);
  const [formData, setFormData] = useState({
    name: '',
    password: ''
  });
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setError('');

    // Validation
    if (isLogin) {
      if (!formData.name || !formData.password) {
        setError('Por favor, preencha todos os campos');
        return;
      }
    } else {
      if (!formData.name || !formData.password) {
        setError('Por favor, preencha todos os campos');
        return;
      }
    }

    toast.success(`${isLogin ? 'Login' : 'Cadastro'} efetuado com sucesso!`);

    sessionStorage.setItem('userName', formData.name);

    setActiveScreen('home')
  };

  return (
    <div className="flex items-center justify-center z-50">
      <div className="bg-white rounded-lg w-full max-w-md mx-4 overflow-hidden">
        {/* Header */}
        <div className="bg-teal-800 text-white p-4 flex items-center justify-between">
          <h2 className="text-xl font-medium">{isLogin ? 'Entrar na conta' : 'Criar nova conta'}</h2>
        </div>

        {/* Form */}
        <div className="p-6">
          <form onSubmit={handleSubmit}>
            {/* Name - only for registration */}
            <div className="mb-4">
              <label className="block text-gray-700 text-sm font-medium mb-2">Nome</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <User size={18} className="text-gray-400" />
                </div>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                  placeholder={!isLogin ? "Seu nome completo" : "Nome de usuário"}
                />
              </div>
            </div>

            {/* Password */}
            <div className="mb-6">
              <label className="block text-gray-700 text-sm font-medium mb-2">Senha</label>
              <div className="relative">
                <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <Lock size={18} className="text-gray-400" />
                </div>
                <input
                  type="password"
                  name="password"
                  value={formData.password}
                  onChange={handleChange}
                  className="w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg focus:ring-teal-500 focus:border-teal-500"
                  placeholder={isLogin ? "Sua senha" : "Crie uma senha"}
                />
              </div>
            </div>

            {/* Error message */}
            {error && (
              <div className="mb-4 p-3 bg-red-100 text-red-700 rounded-lg">
                {error}
              </div>
            )}

            {/* Submit button */}
            <button
              type="submit"
              className="w-full bg-teal-700 hover:bg-teal-800 text-white font-medium py-3 rounded-lg flex items-center justify-center"
            >
              {isLogin ? 'Entrar' : 'Cadastrar'}
              <ArrowRight size={18} className="ml-2" />
            </button>
          </form>

          {/* Toggle login/register */}
          <div className="mt-6 text-center">
            <p className="text-gray-600">
              {isLogin ? 'Ainda não tem uma conta?' : 'Já tem uma conta?'}
              <button
                type="button"
                onClick={() => setIsLogin(!isLogin)}
                className="ml-2 text-teal-600 font-medium hover:text-teal-700"
              >
                {isLogin ? 'Cadastre-se' : 'Entrar'}
              </button>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthModal;